import { motion } from "framer-motion";
import Picture from "../../../components/Picture";
import SectionLabel from "../../../components/SectionLabel";

const LAYOUT = [
    "md:col-span-8 aspect-[16/9]",
    "md:col-span-4 aspect-[4/5]",
    "md:col-span-5 aspect-[4/3]",
    "md:col-span-7 aspect-[16/9]",
    "md:col-span-6 aspect-[4/3]",
    "md:col-span-6 aspect-[4/3]",
];

export default function ExtendedGallery({ base, gallery }) {
    return (
        <section className="bg-[#0B0B0C] border-t border-[rgba(201,168,106,0.1)] overflow-hidden">
            <div className="shell py-20 md:py-28">
                <SectionLabel number="01" label="Extended Gallery" />
                <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
                    {gallery.map((s, i) => {
                        const cls = LAYOUT[i % LAYOUT.length];
                        return (
                            <motion.div
                                key={`${s}-${i}`}
                                initial={{ opacity: 0, y: 14 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.15 }}
                                transition={{
                                    duration: 0.8,
                                    delay: (i % 4) * 0.05,
                                    ease: [0.22, 1, 0.36, 1],
                                }}
                                className={`relative overflow-hidden ${cls}`}
                                data-testid={`private-gallery-${i}`}
                            >
                                <Picture
                                    slug={s}
                                    alt={`${base.name} — image ${i + 1}`}
                                    sizes="(max-width: 768px) 100vw, 60vw"
                                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1400ms] ease-out hover:scale-[1.04]"
                                />
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
